<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Detail Remunerasi'">
          <template v-slot:body>
            <div class="row align-items-center">

              <!-- Profile Image -->
              <div class="col-md-4">
                <div class="d-flex justify-content-center align-items-center image-container">
                  <div style='height: 350px; width: 350px; position: relative'>
                    <img
                      class="image"
                      src="/images/expense-splash.svg"
                    >
                  </div>
                </div>
              </div>

              <!-- Table Data -->
              <div
                class="col"
              >
                <table class="table mb-3">
                  <tr>
                    <td style="width: 25%"><strong>Nama Karyawan</strong></td>
                    <td>{{ data.employee_name }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Tipe Remunerasi</strong></td>
                    <td>{{ data.remuneration_type_name }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Jumlah</strong></td>
                    <td>{{ data.ammount }}</td>
                  </tr>
                 
                </table>

                <button
                  @click="$router.push({path: '/masters/remunerations/Edit/' + data.id})"
                  class="btn mx-1 btn-success"
                  v-if="manipulateBtn == true"
                ><i class="far fa-fw fa-edit"></i> Edit</button>
                <button
                  @click="deleteData"
                  class="btn mx-1 btn-danger"
                  v-if="manipulateBtn == true"
                ><i class="far fa-fw fa-trash-alt"></i> Hapus</button>
              </div>

            </div>
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      // Data
      data: {
        employee_name:"",
        remuneration_type_name:"",
        ammount:"",
      },
      // Other
      imgLoaded: false,
      manipulateBtn:false,
    }
  },

  components: {
    Card,
  },

  methods: {

    async deleteData() {
      let result = await module.delete('remunerations/' + this.$route.params.id)
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push('/masters/remunerations/list')
      }
    },

    async get() {
      this.data = await module.get('remunerations/' + this.$route.params.id)
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/masters/remunerations/list')
      }
    },

    // access management
    async setActiveMenu(){

     let access_right_user = window.localStorage.getItem("access_right_display")
     let access_right = JSON.parse(access_right_user)
    
    let a
    for(a = 0; a < access_right.length; a++){
      
      
      if(access_right[a] == "7006"){
        this.manipulateBtn = true
      }
      
    }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Remunerasi", route: "" },
      { title: "Daftar Remunerasi", route: "/masters/remunerations/list" },
      { title: "Detail" },
    ])
    // Get Data
    this.get()
    this.setActiveMenu()
  },
}

</script>